<template>
  <v-row class="my-0">
    <v-col cols="6" class="pe-0">
      <v-text-field
        data-private
        dense
        outlined
        hide-details
        class="mb-4"
        type="number"
        name="milliseconds"
        v-model="time"
        :label="label"
        :disabled="disabled"
        @keypress="preventDot"
        @input="updateTime"
      />
    </v-col>
    <v-col cols="6">
      <v-select
        outlined
        dense
        hide-details
        class="mb-4"
        v-model="timeUnit"
        :disabled="disabled"
        :label="$t('rev.time_tracking.time_unit')"
        :items="timeUnitOptions"
        @input="updateTimeUnit"
      />
    </v-col>
  </v-row>
</template>
<script>
export default {
  name: 'TimeTrackingEditMode',

  props: {
    initialTime: {
      required: false,
      type: Number,
    },
    label: {
      required: false,
      type: String,
    },
    initialTimeUnit: {
      required: false,
      type: String,
    },
    timeUnitOptions: {
      required: true,
      type: Array,
    },
    disabled: {
      required: false,
      type: Boolean,
    },
  },

  data() {
    return {
      time: this.initialTime,
      timeUnit: this.initialTimeUnit,
    }
  },

  watch: {
    initialTime: {
      handler(newValue) {
        this.time = newValue
      },
    },
    initialTimeUnit: {
      handler(newValue) {
        this.timeUnit = newValue
      },
    },
  },

  methods: {
    preventDot(event) {
      if (event.key === '.') event.preventDefault()
    },

    updateTime(time) {
      this.$emit('update', { time, timeUnit: this.timeUnit })
    },

    updateTimeUnit(timeUnit) {
      this.$emit('update', { time: this.time, timeUnit })
    },
  },
}
</script>
